import React from 'react';
import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';
import CustomTextInput from '../../../common/components/CustomTextInput';
import CloseConfirmPopup from '../../../common/components/CloseConfirmPopup';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicEditTitlePopupViewFieldName = 'title';

export default function MusicEditTitlePopupView({
  isModified,
  onClose,
  onSave,
  onDelete,
  getValue,
  setValue,
  getErrors,
} : {
  isModified: boolean,
  onClose: () => void,
  onSave: () => void,
  onDelete: () => void,
  getValue: (name: MusicEditTitlePopupViewFieldName) => string,
  setValue: (name: MusicEditTitlePopupViewFieldName, value: string) => void,
  getErrors: (name: MusicEditTitlePopupViewFieldName) => FieldValidationErrorsType,
}) {
  const [closeConfirm, setCloseConfirm] = React.useState(false);

  const handleClose = () => {
    if (isModified) {
      setCloseConfirm(true);
    } else {
      onClose();
    }
  };

  return (
    <>
      <PopupContainer
        title="曲情報の入力"
        onClose={() => handleClose()}
      >
        <form className="cake_ajax_form">
          <div className="form__body">
            <dl>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <dt><label htmlFor="/">曲名</label></dt>
              <dd>
                <CustomTextInput
                  placeholder="Frekul Song"
                  value={getValue('title')}
                  setValue={(value) => setValue('title', value)}
                  validationErrors={getErrors('title')}
                />
                <p className="text_info_off">ここに説明文。</p>
              </dd>
            </dl>
            <p className="info">
              曲名以外の情報を編集したい場合は「
              <a href="/music_albums">音楽配信の管理</a>
              」ページで入力してください。
            </p>
            <ul>
              <li className="bt">
                <CustomButton type="cancel-split" onClick={() => handleClose()}>戻る</CustomButton>
                <CustomButton type="default-split" onClick={() => onSave()}>保存</CustomButton>
              </li>
            </ul>
            <div style={{ textAlign: 'right' }}>
              <CustomButton type="secondary-cancel" onClick={() => onDelete()}>曲の削除</CustomButton>
            </div>
          </div>
        </form>
      </PopupContainer>
      {closeConfirm && (
        <CloseConfirmPopup
          onClose={() => {
            setCloseConfirm(false);
            onClose();
          }}
          onCancel={() => {
            setCloseConfirm(false);
          }}
        />
      )}
    </>
  );
}
